import React from 'react';

import {
  Button,
  ButtonGroup,
  Dialog,
  DialogMessage,
  DialogTitle,
  Overlay,
} from './styles';
import { useConfigs } from '../../context/ConfigsContext';

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  const { cores } = useConfigs();

  return (
    <Overlay open={open}>
      <Dialog cores={cores}>
        <DialogTitle cores={cores}>{title}</DialogTitle>
        <DialogMessage cores={cores}>{message}</DialogMessage>
        <ButtonGroup>
          <Button variant={'cancel'} onClick={onCancel}>
            NÃO
          </Button>
          <Button variant={'confirm'} onClick={onConfirm}>
            SIM
          </Button>
        </ButtonGroup>
      </Dialog>
    </Overlay>
  );
};

export default ConfirmationModal;
